const ITEMS = [
  { text: "SOUND DESIGN ELETTRONICO", strong: true },
  { text: "CINEMATIC AMBIENT" },
  { text: "17 BRANI SU SPOTIFY", accent: true },
  { text: "COLONNE SONORE PER CORTOMETRAGGI" },
  { text: "PRODUZIONE DIGITALE" },
  { text: "GRAFICA E SUONO", strong: true },
];

const Row = () => (
  <div className="flex items-center gap-10">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center gap-10">
        <span
          className={
            item.strong
              ? "text-white tracking-widest font-disp uppercase font-semibold"
              : item.accent
                ? "text-indigo-400 font-semibold"
                : undefined
          }
        >
          {item.text}
        </span>
        <span>&bull;</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee-strip" className="border-b border-[#1e2335] bg-[#0c0e17] py-4 overflow-hidden">
    <div className="mq-track gap-10 items-center text-xs font-mono-code text-[#64748b]">
      <Row />
      <Row />
    </div>
  </div>
);
